import { memo } from 'react';
import ItemDiscountTag from '../../../core/components/ItemDiscountTag';
import type { ProductCustomerPrice } from '../../types';

const ProductPriceDiscountTag = ({
    customerPrice,
    onSale,
}: {
    customerPrice: ProductCustomerPrice;
    onSale: boolean;
}) => {
    const dealerDiscountPercentage =
        customerPrice.dealerDiscountPercentage || 0;
    const additionalDiscountPercentage =
        customerPrice.additionalDiscountPercentage || 0;
    const { appliedDiscountRule } = customerPrice;

    return (
        <ItemDiscountTag
            dealerDiscountPercentage={dealerDiscountPercentage}
            additionalDiscountPercentage={additionalDiscountPercentage}
            isSpecial={appliedDiscountRule === 'specialPrice'}
            onSale={onSale}
        />
    );
};

export default memo(ProductPriceDiscountTag);
